export default __webpack_public_path__ + "assets/651c91368d7573e7124f8df9ba5bad3e.svg";